import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts'
import { cn } from '@/lib/utils'

interface SeriesDef {
  key: string
  label: string
  color: string
}

interface RevenueLineChartProps {
  data: object[]
  xKey: string
  series: SeriesDef[]
  height?: number
  title?: string
  className?: string
}

export function RevenueLineChart({ data, xKey, series, height = 300, title, className }: RevenueLineChartProps) {
  return (
    <div className={cn('rounded-xl border border-border bg-card p-5', className)}>
      {title && <h3 className="mb-4 text-sm font-medium text-muted-foreground">{title}</h3>}
      <ResponsiveContainer width="100%" height={height}>
        <LineChart data={data} margin={{ top: 5, right: 20, bottom: 5, left: 0 }}>
          <CartesianGrid strokeDasharray="3 3" className="stroke-border" />
          <XAxis dataKey={xKey} tick={{ fontSize: 12 }} className="text-muted-foreground"
            tickFormatter={(v: string) => { const d = new Date(v); return `${d.getMonth() + 1}/${d.getDate()}` }} />
          <YAxis tick={{ fontSize: 12 }} className="text-muted-foreground"
            tickFormatter={(v: number) => { if (v >= 1000000) return `${(v / 1000000).toFixed(1)}M`; if (v >= 1000) return `${(v / 1000).toFixed(0)}K`; return String(v) }} />
          <Tooltip contentStyle={{ backgroundColor: 'hsl(var(--card))', border: '1px solid hsl(var(--border))', borderRadius: '8px', fontSize: '12px' }} />
          {series.map((s) => (
            <Line key={s.key} type="monotone" dataKey={s.key} name={s.label} stroke={s.color} strokeWidth={2} dot={false} activeDot={{ r: 4 }} />
          ))}
        </LineChart>
      </ResponsiveContainer>
    </div>
  )
}
